export default __webpack_public_path__ + "static/media/SourceSans3-Italic.bf796740.ttf";